import ChatService from '@/service/chat'
export default {
    methods: {
        async addEvaluate(id){
            const { permission } = await ChatService.getRatingAuth(id)
            if(!permission.allow){
                wx.showToast({
                    title: permission.message,
                    icon: 'none'
                })
                return
            }
            this.show_evaluate_dialog = true
        },
        async submitRate (score,id) {
            await ChatService.addRating(id, score)
            this.rating = score
            this.show_evaluate_dialog = false
            wx.showToast({
                title: '评价成功'
            })
        }
    }
}